import { FC } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';

import './MobileInstallDialog.scss';
import MobileApp from '../../../assets/common/mobile_app.png';
import AppStore from '../../../assets/settings/appstore.png';
import PlayStore from '../../../assets/settings/playstore.png';

interface MobileInstallDialogProps {
  visible: boolean;
  onClose: () => void;
}

const MobileInstallDialog: FC<MobileInstallDialogProps> = ({ visible, onClose }) => {
  return (
    <Dialog
      open={visible}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="mobile-install-dialog"
    >
      <DialogTitle className="mobile-install-dialog__title">
        <Typography variant="h3" className="mobile-install-dialog__title-text">
          Try Lifestack mobile app!
        </Typography>
      </DialogTitle>
      <DialogContent className="mobile-install-dialog__content">
        <Typography variant="body2" className="mobile-install-dialog__content__description">
          Check your energy on the go and access your calendar through the Lifestack mobile app.
        </Typography>
        <div className="mobile-install-dialog__content__image">
          <img src={MobileApp} alt="Mobile App" style={{ width: '60%' }} />
        </div>
        <div className="mobile-install-dialog__content__store-links">
          <a
            href="https://apps.apple.com/us/app/lifestack-calendar-and-health/id6473464429"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={AppStore}
              alt="App Store"
              draggable="false"
              className="mobile-install-dialog__content__store-links__image"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.demind.lifestack_calendar&hl=en_US&gl=US"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={PlayStore}
              alt="Play Store"
              draggable="false"
              className="mobile-install-dialog__content__store-links__image"
            />
          </a>
        </div>
      </DialogContent>
      <div className="mobile-install-dialog__divider-container">
        <Divider className="mobile-install-dialog__divider" />
      </div>
      <DialogActions className="mobile-install-dialog__actions">
        <Button onClick={onClose} className="mobile-install-dialog__actions__cta-button">
          <Typography variant="body2" className="mobile-install-dialog__actions__cta-text">
            OK
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MobileInstallDialog;
